import React, { Component } from "react";

class AdminDashboard extends Component {
  render() {
    return <div />;
  }
}

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/components/admin/index.js